module.exports = __webpack_public_path__ + "static/img/470.42633c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/470.png
// module id = 3otw
// module chunks = 1